(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-sigma-article]');
    if (!root) return;

    var body = root.querySelector('[data-article-body]');
    var layout = root.querySelector('.sigma-article__layout');
    var tocWrap = root.querySelector('[data-article-toc-wrap]');
    var tocMobile = root.querySelector('[data-article-toc-mobile]');
    var tocList = root.querySelector('[data-article-toc-list]');
    var tocListMobile = root.querySelector('[data-article-toc-list-mobile]');
    var minHeadings = 3;

    function slugify(text) {
      return String(text || '')
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .slice(0, 80);
    }

    function buildToc() {
      if (!body) return;
      var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
      if (headings.length < minHeadings) return;

      var used = {};
      headings.forEach(function (h, index) {
        var base = slugify(h.textContent) || 'section-' + (index + 1);
        var id = base;
        var n = 2;
        while (used[id] || document.getElementById(id)) {
          id = base + '-' + n;
          n += 1;
        }
        used[id] = true;
        h.id = id;

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent;
        li.appendChild(a);
        if (tocList) tocList.appendChild(li);

        if (tocListMobile) {
          var liM = li.cloneNode(true);
          tocListMobile.appendChild(liM);
        }
      });

      if (tocWrap) tocWrap.hidden = false;
      if (tocMobile) tocMobile.hidden = false;
      if (layout) layout.classList.add('has-toc');

      setupTocNavigation(headings);
    }

    function setupTocNavigation(headings) {
      var links = root.querySelectorAll('.sigma-article__toc-list a');
      if (!links.length) return;

      links.forEach(function (link) {
        link.addEventListener('click', function (event) {
          var href = link.getAttribute('href');
          if (!href || href.charAt(0) !== '#') return;
          var target = document.getElementById(href.slice(1));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (tocMobile && tocMobile.open) {
            tocMobile.open = false;
          }
        });
      });

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var id = entry.target.id;
            links.forEach(function (link) {
              link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
            });
          });
        },
        { rootMargin: '-20% 0px -65% 0px', threshold: 0 }
      );
      headings.forEach(function (h) {
        observer.observe(h);
      });
    }

    function setupProgressBar() {
      var progressBar = root.querySelector('[data-article-progress-bar]');
      if (!progressBar) return;

      var ticking = false;

      function updateProgress() {
        ticking = false;
        var rect = root.getBoundingClientRect();
        var scrollTop = window.scrollY || document.documentElement.scrollTop;
        var start = scrollTop + rect.top;
        var end = start + root.offsetHeight - window.innerHeight;
        var progress = 0;

        if (end <= start) {
          progress = scrollTop >= start ? 1 : 0;
        } else {
          progress = (scrollTop - start) / (end - start);
        }

        progress = Math.min(1, Math.max(0, progress));
        progressBar.style.transform = 'scaleX(' + progress + ')';
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateProgress);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      updateProgress();
    }

    function setupShare() {
      var shareRoot = root.querySelector('[data-article-share]');
      if (!shareRoot) return;
      var nativeBtn = shareRoot.querySelector('[data-share-native]');
      var copyBtn = shareRoot.querySelector('[data-share-copy]');
      var status = shareRoot.querySelector('[data-share-status]');
      var url = window.location.href;
      var title = document.title;

      function flash(msg) {
        if (!status) return;
        status.textContent = msg;
        window.setTimeout(function () {
          status.textContent = '';
        }, 2000);
      }

      if (nativeBtn && typeof navigator.share === 'function') {
        nativeBtn.hidden = false;
        nativeBtn.addEventListener('click', function () {
          navigator.share({ title: title, url: url }).catch(function () {});
        });
      }

      if (copyBtn) {
        var label = copyBtn.getAttribute('data-label') || copyBtn.textContent;
        var copiedLabel = copyBtn.getAttribute('data-copied-label') || 'Copied';
        copyBtn.addEventListener('click', function () {
          function onCopied() {
            flash(copiedLabel);
            copyBtn.textContent = copiedLabel;
            window.setTimeout(function () {
              copyBtn.textContent = label;
            }, 2000);
          }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(onCopied, function () {});
          } else {
            var input = document.createElement('input');
            input.value = url;
            document.body.appendChild(input);
            input.select();
            try {
              document.execCommand('copy');
              onCopied();
            } catch (e) {}
            document.body.removeChild(input);
          }
        });
      }
    }

    buildToc();
    setupShare();
    setupProgressBar();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-sigma-header-drawer]').forEach(function (drawer) {
      var closeBtn = drawer.querySelector('[data-sigma-header-drawer-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          drawer.removeAttribute('open');
        });
      }
      drawer.querySelectorAll('.sigma-header__drawer-nav a').forEach(function (a) {
        a.addEventListener('click', function () {
          drawer.removeAttribute('open');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-mobile-app"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    const DURATION_MS = 28000
    const DRAG_THRESHOLD = 5
    /** >1 = more track movement per finger pixel while dragging */
    const SWIPE_SENSITIVITY = 3.5
    /** Momentum after release (ms shift per px/ms velocity) */
    const FLICK_FACTOR = 480
    /** On a quick flick, advance at least ~one card even for short swipes */
    const MIN_FLICK_VELOCITY = 0.18
    const MIN_FLICK_SLIDE_FRACTION = 1

    document.querySelectorAll('[data-lma-testi-viewport]').forEach((viewport) => {
      if (viewport.dataset.lmaTestiSwipeInit === '1') return

      const track = viewport.querySelector('.lma-testi__track')
      if (!track) return

      const anims = track.getAnimations().filter((a) => a.animationName === 'lma-testi-marquee')
      if (!anims.length) return

      const anim = anims[0]
      viewport.dataset.lmaTestiSwipeInit = '1'

      let startX = 0
      let startY = 0
      let startTime = 0
      let dragStartT = 0
      let dragging = false
      let pxPerMs = 0
      let msPerSlideBase = 0
      let lastX = 0
      let lastT = 0
      let velocity = 0

      const getMetrics = () => {
        const seq = track.querySelector('.lma-testi__sequence')
        const slide = track.querySelector('.landing-testimonials__slide')
        if (!seq) return { pxPerMs: 0, msPerSlideBase: 0 }

        const seqW = seq.offsetWidth
        if (seqW <= 0) return { pxPerMs: 0, msPerSlideBase: 0 }

        const msPerPx = DURATION_MS / seqW
        const pxMs = msPerPx * SWIPE_SENSITIVITY
        let slideMsBase = 0
        if (slide) {
          const gap = Number.parseFloat(getComputedStyle(seq).columnGap || getComputedStyle(seq).gap || '0') || 12
          slideMsBase = msPerPx * (slide.offsetWidth + gap)
        }

        return { pxPerMs: pxMs, msPerSlideBase: slideMsBase }
      }

      const wrapTime = (t) => {
        const m = t % DURATION_MS
        return m < 0 ? m + DURATION_MS : m
      }

      viewport.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return
        startX = e.clientX
        startY = e.clientY
        lastX = startX
        lastT = performance.now()
        dragStartT = lastT
        velocity = 0
        dragging = false
        startTime = anim.currentTime
        const metrics = getMetrics()
        pxPerMs = metrics.pxPerMs
        msPerSlideBase = metrics.msPerSlideBase
        if (viewport.setPointerCapture) viewport.setPointerCapture(e.pointerId)
      })

      viewport.addEventListener(
        'pointermove',
        (e) => {
          const dx = e.clientX - startX
          const dy = e.clientY - startY

          if (!dragging) {
            if (Math.abs(dx) <= DRAG_THRESHOLD || Math.abs(dx) <= Math.abs(dy)) return
            dragging = true
            track.classList.add('is-dragging')
            anim.pause()
          }

          e.preventDefault()

          const now = performance.now()
          const dt = now - lastT
          if (dt > 0) velocity = (e.clientX - lastX) / dt
          lastX = e.clientX
          lastT = now

          if (pxPerMs > 0) {
            anim.currentTime = wrapTime(startTime - dx * pxPerMs)
          }
        },
        { passive: false }
      )

      const endDrag = (e) => {
        if (viewport.releasePointerCapture) {
          try {
            viewport.releasePointerCapture(e.pointerId)
          } catch (_) {
            /* pointer may already be released */
          }
        }

        if (!dragging) return

        dragging = false
        track.classList.remove('is-dragging')

        const gestureDx = e.clientX - startX
        const gestureMs = Math.max(1, performance.now() - dragStartT)
        const gestureVelocity = gestureDx / gestureMs

        if (pxPerMs > 0 && Math.abs(gestureDx) > DRAG_THRESHOLD) {
          const flickSpeed = Math.max(Math.abs(velocity), Math.abs(gestureVelocity))
          let flickMs = flickSpeed * FLICK_FACTOR
          if (flickSpeed >= MIN_FLICK_VELOCITY && msPerSlideBase > 0) {
            flickMs = Math.max(flickMs, msPerSlideBase * MIN_FLICK_SLIDE_FRACTION)
          }
          const direction = gestureDx < 0 ? 1 : -1
          anim.currentTime = wrapTime(anim.currentTime + direction * flickMs)
        }

        anim.play()
      }

      viewport.addEventListener('pointerup', endDrag)
      viewport.addEventListener('pointercancel', endDrag)
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-accordion-mobile"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = Array.from(document.querySelectorAll('.section-product-details-accordion-mobile [data-pmda-root]'))
    if (!roots.length) return

    const motionReduce = window.matchMedia('(prefers-reduced-motion: reduce)')

    const clearSizerStyles = (sizer) => {
      sizer.style.height = ''
      sizer.style.transition = ''
      sizer.style.overflow = ''
    }

    const animateOpen = (item, sizer) => {
      item.dataset.pmdaAccordionAnimating = '1'
      item.open = true
      sizer.style.overflow = 'hidden'
      sizer.style.height = '0px'
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const h = sizer.scrollHeight
          sizer.style.transition = 'height 0.38s cubic-bezier(0.22, 1, 0.36, 1)'
          sizer.style.height = `${h}px`
        })
      })

      const onEnd = (e) => {
        if (e.target !== sizer || e.propertyName !== 'height') return
        window.clearTimeout(failSafe)
        sizer.removeEventListener('transitionend', onEnd)
        clearSizerStyles(sizer)
        item.dataset.pmdaAccordionAnimating = ''
      }
      sizer.addEventListener('transitionend', onEnd)
      const failSafe = window.setTimeout(() => {
        if (item.dataset.pmdaAccordionAnimating !== '1') return
        sizer.removeEventListener('transitionend', onEnd)
        clearSizerStyles(sizer)
        item.dataset.pmdaAccordionAnimating = ''
      }, 600)
    }

    const animateClose = (item, sizer) => {
      item.dataset.pmdaAccordionAnimating = '1'
      const h = sizer.scrollHeight
      sizer.style.overflow = 'hidden'
      sizer.style.height = `${h}px`
      sizer.offsetHeight
      requestAnimationFrame(() => {
        sizer.style.transition = 'height 0.32s cubic-bezier(0.22, 1, 0.36, 1)'
        sizer.style.height = '0px'
      })

      const onEnd = (e) => {
        if (e.target !== sizer || e.propertyName !== 'height') return
        window.clearTimeout(failSafe)
        sizer.removeEventListener('transitionend', onEnd)
        item.open = false
        clearSizerStyles(sizer)
        item.dataset.pmdaAccordionAnimating = ''
      }
      sizer.addEventListener('transitionend', onEnd)
      const failSafe = window.setTimeout(() => {
        if (item.dataset.pmdaAccordionAnimating !== '1') return
        sizer.removeEventListener('transitionend', onEnd)
        item.open = false
        clearSizerStyles(sizer)
        item.dataset.pmdaAccordionAnimating = ''
      }, 600)
    }

    roots.forEach((accordionRoot) => {
      if (accordionRoot.dataset.pmdaAccordionInit === '1') return
      accordionRoot.dataset.pmdaAccordionInit = '1'

      const items = Array.from(accordionRoot.querySelectorAll('.pmda-item'))

      if (items.length >= 2) {
        items.forEach((item) => {
          item.addEventListener('toggle', () => {
            if (!item.open) return
            items.forEach((otherItem) => {
              if (otherItem !== item) {
                otherItem.open = false
              }
            })
          })
        })
      }

      items.forEach((item) => {
        const summary = item.querySelector('summary.pmda-summary')
        const sizer = item.querySelector('[data-pmda-accordion-sizer]')
        if (!summary || !sizer) return

        summary.addEventListener('click', (e) => {
          if (motionReduce.matches) return
          if (item.dataset.pmdaAccordionAnimating === '1') {
            e.preventDefault()
            return
          }
          e.preventDefault()
          if (!item.open) {
            animateOpen(item, sizer)
          } else {
            animateClose(item, sizer)
          }
        })
      })
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-accordion-no-icons"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const accordionRoots = Array.from(
      document.querySelectorAll(
        '.section-product-details-accordion .pdp-details-accordion,' +
          '.section-product-details-accordion-no-icons .pdp-details-accordion'
      )
    )
    if (!accordionRoots.length) return

    const motionReduce = window.matchMedia('(prefers-reduced-motion: reduce)')
    const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)'
    const OPEN_MS = 380
    const CLOSE_MS = 320

    const clearSizerStyles = (sizer) => {
      sizer.style.height = ''
      sizer.style.transition = ''
      sizer.style.overflow = ''
    }

    const getSizer = (item) => item.querySelector('[data-pdp-accordion-sizer]')

    const setItemClosing = (item, isClosing) => {
      if (isClosing) {
        item.dataset.pdpAccordionClosing = '1'
      } else {
        delete item.dataset.pdpAccordionClosing
      }
    }

    const cancelItemAnimationListeners = (item) => {
      const cancel = item._pdpAccordionCancel
      if (typeof cancel === 'function') {
        cancel()
      }
      item._pdpAccordionCancel = null
      item.dataset.pdpAccordionAnimating = ''
    }

    const cancelItemAnimation = (item, sizer) => {
      cancelItemAnimationListeners(item)
      setItemClosing(item, false)
      clearSizerStyles(sizer)
    }

    const watchHeightAnimation = (item, sizer, durationMs, onComplete) => {
      const finish = () => {
        if (item._pdpAccordionCancel !== cleanup) return
        item._pdpAccordionCancel = null
        sizer.removeEventListener('transitionend', onEnd)
        window.clearTimeout(failSafe)
        onComplete()
      }

      const onEnd = (e) => {
        if (e.target !== sizer || e.propertyName !== 'height') return
        finish()
      }

      const cleanup = finish
      item._pdpAccordionCancel = cleanup

      sizer.addEventListener('transitionend', onEnd)
      const failSafe = window.setTimeout(finish, durationMs + 120)
    }

    const runHeightAnimation = (item, sizer, { durationMs, toHeight, onComplete }) => {
      cancelItemAnimationListeners(item)
      item.dataset.pdpAccordionAnimating = '1'

      watchHeightAnimation(item, sizer, durationMs, () => {
        clearSizerStyles(sizer)
        item.dataset.pdpAccordionAnimating = ''
        onComplete()
      })

      requestAnimationFrame(() => {
        if (!item._pdpAccordionCancel) return
        sizer.style.transition = `height ${durationMs}ms ${EASING}`
        sizer.style.height = toHeight
      })
    }

    const animateOpen = (item, sizer) => {
      cancelItemAnimation(item, sizer)
      item.open = true
      sizer.style.overflow = 'hidden'
      sizer.style.transition = ''
      sizer.style.height = '0px'

      requestAnimationFrame(() => {
        if (!item.open) return
        runHeightAnimation(item, sizer, {
          durationMs: OPEN_MS,
          toHeight: `${sizer.scrollHeight}px`,
          onComplete: () => {},
        })
      })
    }

    const animateClose = (item, sizer) => {
      if (!item.open) return

      cancelItemAnimationListeners(item)
      setItemClosing(item, true)
      item.dataset.pdpAccordionAnimating = '1'

      sizer.style.overflow = 'hidden'
      sizer.style.transition = ''
      sizer.style.height = `${sizer.scrollHeight}px`
      void sizer.offsetHeight

      watchHeightAnimation(item, sizer, CLOSE_MS, () => {
        item.open = false
        setItemClosing(item, false)
        clearSizerStyles(sizer)
        item.dataset.pdpAccordionAnimating = ''
      })

      sizer.style.transition = `height ${CLOSE_MS}ms ${EASING}`
      sizer.style.height = '0px'
    }

    const closeOthersWithAnimation = (items, exceptItem) => {
      items.forEach((otherItem) => {
        if (otherItem === exceptItem || !otherItem.open) return
        const otherSizer = getSizer(otherItem)
        if (!otherSizer) {
          otherItem.open = false
          return
        }
        animateClose(otherItem, otherSizer)
      })
    }

    accordionRoots.forEach((accordionRoot) => {
      if (accordionRoot.dataset.pdpAccordionInit === '1') return
      accordionRoot.dataset.pdpAccordionInit = '1'

      const items = Array.from(accordionRoot.querySelectorAll('.pdp-details-accordion__item'))

      items.forEach((item) => {
        const summary = item.querySelector('summary.pdp-details-accordion__summary')
        const sizer = getSizer(item)
        if (!summary || !sizer) return

        summary.addEventListener('click', (e) => {
          if (motionReduce.matches) return
          if (item.dataset.pdpAccordionAnimating === '1') {
            e.preventDefault()
            return
          }
          e.preventDefault()
          if (!item.open) {
            if (items.length >= 2) {
              closeOthersWithAnimation(items, item)
            }
            animateOpen(item, sizer)
          } else {
            animateClose(item, sizer)
          }
        })
      })
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-accordion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const accordionRoots = Array.from(
      document.querySelectorAll(
        '.section-product-details-accordion .pdp-details-accordion,' +
          '.section-product-details-accordion-no-icons .pdp-details-accordion'
      )
    )
    if (!accordionRoots.length) return

    const motionReduce = window.matchMedia('(prefers-reduced-motion: reduce)')
    const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)'
    const OPEN_MS = 380
    const CLOSE_MS = 320

    const clearSizerStyles = (sizer) => {
      sizer.style.height = ''
      sizer.style.transition = ''
      sizer.style.overflow = ''
    }

    const getSizer = (item) => item.querySelector('[data-pdp-accordion-sizer]')

    const setItemClosing = (item, isClosing) => {
      if (isClosing) {
        item.dataset.pdpAccordionClosing = '1'
      } else {
        delete item.dataset.pdpAccordionClosing
      }
    }

    const cancelItemAnimationListeners = (item) => {
      const cancel = item._pdpAccordionCancel
      if (typeof cancel === 'function') {
        cancel()
      }
      item._pdpAccordionCancel = null
      item.dataset.pdpAccordionAnimating = ''
    }

    const cancelItemAnimation = (item, sizer) => {
      cancelItemAnimationListeners(item)
      setItemClosing(item, false)
      clearSizerStyles(sizer)
    }

    const watchHeightAnimation = (item, sizer, durationMs, onComplete) => {
      const finish = () => {
        if (item._pdpAccordionCancel !== cleanup) return
        item._pdpAccordionCancel = null
        sizer.removeEventListener('transitionend', onEnd)
        window.clearTimeout(failSafe)
        onComplete()
      }

      const onEnd = (e) => {
        if (e.target !== sizer || e.propertyName !== 'height') return
        finish()
      }

      const cleanup = finish
      item._pdpAccordionCancel = cleanup

      sizer.addEventListener('transitionend', onEnd)
      const failSafe = window.setTimeout(finish, durationMs + 120)
    }

    const runHeightAnimation = (item, sizer, { durationMs, toHeight, onComplete }) => {
      cancelItemAnimationListeners(item)
      item.dataset.pdpAccordionAnimating = '1'

      watchHeightAnimation(item, sizer, durationMs, () => {
        clearSizerStyles(sizer)
        item.dataset.pdpAccordionAnimating = ''
        onComplete()
      })

      requestAnimationFrame(() => {
        if (!item._pdpAccordionCancel) return
        sizer.style.transition = `height ${durationMs}ms ${EASING}`
        sizer.style.height = toHeight
      })
    }

    const animateOpen = (item, sizer) => {
      cancelItemAnimation(item, sizer)
      item.open = true
      sizer.style.overflow = 'hidden'
      sizer.style.transition = ''
      sizer.style.height = '0px'

      requestAnimationFrame(() => {
        if (!item.open) return
        runHeightAnimation(item, sizer, {
          durationMs: OPEN_MS,
          toHeight: `${sizer.scrollHeight}px`,
          onComplete: () => {},
        })
      })
    }

    const animateClose = (item, sizer) => {
      if (!item.open) return

      cancelItemAnimationListeners(item)
      setItemClosing(item, true)
      item.dataset.pdpAccordionAnimating = '1'

      sizer.style.overflow = 'hidden'
      sizer.style.transition = ''
      sizer.style.height = `${sizer.scrollHeight}px`
      void sizer.offsetHeight

      watchHeightAnimation(item, sizer, CLOSE_MS, () => {
        item.open = false
        setItemClosing(item, false)
        clearSizerStyles(sizer)
        item.dataset.pdpAccordionAnimating = ''
      })

      sizer.style.transition = `height ${CLOSE_MS}ms ${EASING}`
      sizer.style.height = '0px'
    }

    const closeOthersWithAnimation = (items, exceptItem) => {
      items.forEach((otherItem) => {
        if (otherItem === exceptItem || !otherItem.open) return
        const otherSizer = getSizer(otherItem)
        if (!otherSizer) {
          otherItem.open = false
          return
        }
        animateClose(otherItem, otherSizer)
      })
    }

    accordionRoots.forEach((accordionRoot) => {
      if (accordionRoot.dataset.pdpAccordionInit === '1') return
      accordionRoot.dataset.pdpAccordionInit = '1'

      const items = Array.from(accordionRoot.querySelectorAll('.pdp-details-accordion__item'))

      items.forEach((item) => {
        const summary = item.querySelector('summary.pdp-details-accordion__summary')
        const sizer = getSizer(item)
        if (!summary || !sizer) return

        summary.addEventListener('click', (e) => {
          if (motionReduce.matches) return
          if (item.dataset.pdpAccordionAnimating === '1') {
            e.preventDefault()
            return
          }
          e.preventDefault()
          if (!item.open) {
            if (items.length >= 2) {
              closeOthersWithAnimation(items, item)
            }
            animateOpen(item, sizer)
          } else {
            animateClose(item, sizer)
          }
        })
      })
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-key-advantages-mobile"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pmka-carousel]').forEach((track) => {
      const root = track.closest('.pmka-shell')
      if (!root || root.dataset.pmkaCarouselInit === '1') return
      root.dataset.pmkaCarouselInit = '1'

      const dots = Array.from(root.querySelectorAll('[data-pmka-dot]'))
      const slides = () => Array.from(root.querySelectorAll('[data-pmka-slide]'))
      if (!dots.length) return

      const syncDots = () => {
        const list = slides()
        if (!list.length) return
        let best = 0
        let bestDist = Infinity
        const left = track.scrollLeft
        list.forEach((slide, i) => {
          const d = Math.abs(slide.offsetLeft - left)
          if (d < bestDist) {
            bestDist = d
            best = i
          }
        })
        dots.forEach((d, i) => d.classList.toggle('is-active', i === best))
      }

      track.addEventListener('scroll', syncDots, { passive: true })
      dots.forEach((btn) => {
        btn.addEventListener('click', () => {
          const i = Number.parseInt(btn.getAttribute('data-pmka-dot') || '', 10)
          const list = slides()
          if (Number.isNaN(i) || !list[i]) return
          const slide = list[i]
          const target = slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2
          track.scrollTo({ left: Math.max(0, target), behavior: 'smooth' })
        })
      })

      root.querySelectorAll('.pmka-press').forEach((el) => {
        el.addEventListener('pointerdown', () => el.classList.add('is-pressed'))
        ;['pointerup', 'pointercancel', 'pointerleave'].forEach((ev) => {
          el.addEventListener(ev, () => el.classList.remove('is-pressed'))
        })
      })
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-lifestyle-mobile"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    const DURATION_MS = 38000
    const DRAG_THRESHOLD = 5
    const SWIPE_SENSITIVITY = 3.5
    const FLICK_FACTOR = 480
    const MIN_FLICK_VELOCITY = 0.18
    const MIN_FLICK_SLIDE_FRACTION = 1

    document.querySelectorAll('[data-pml-viewport]').forEach((viewport) => {
      if (viewport.dataset.pmlSwipeInit === '1') return

      const track = viewport.querySelector('.pml-track')
      if (!track) return

      const anims = track.getAnimations().filter((a) => a.animationName === 'pml-lifestyle-marquee')
      if (!anims.length) return

      const anim = anims[0]
      viewport.dataset.pmlSwipeInit = '1'

      let startX = 0
      let startY = 0
      let startTime = 0
      let dragStartT = 0
      let dragging = false
      let pxPerMs = 0
      let msPerSlideBase = 0
      let lastX = 0
      let lastT = 0
      let velocity = 0

      const getMetrics = () => {
        const seq = track.querySelector('.pml-sequence')
        const card = track.querySelector('.pml-card')
        if (!seq) return { pxPerMs: 0, msPerSlideBase: 0 }

        const seqW = seq.offsetWidth
        if (seqW <= 0) return { pxPerMs: 0, msPerSlideBase: 0 }

        const msPerPx = DURATION_MS / seqW
        const pxMs = msPerPx * SWIPE_SENSITIVITY
        let slideMsBase = 0
        if (card) {
          const gap = Number.parseFloat(getComputedStyle(seq).columnGap || getComputedStyle(seq).gap || '0') || 10
          slideMsBase = msPerPx * (card.offsetWidth + gap)
        }

        return { pxPerMs: pxMs, msPerSlideBase: slideMsBase }
      }

      const wrapTime = (t) => {
        const m = t % DURATION_MS
        return m < 0 ? m + DURATION_MS : m
      }

      const refreshLayoutMetrics = () => {
        window.setTimeout(() => {
          const metrics = getMetrics()
          pxPerMs = metrics.pxPerMs
          msPerSlideBase = metrics.msPerSlideBase
        }, 100)
      }

      window.addEventListener('orientationchange', refreshLayoutMetrics)
      window.addEventListener('resize', refreshLayoutMetrics)

      viewport.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return
        startX = e.clientX
        startY = e.clientY
        lastX = startX
        lastT = performance.now()
        dragStartT = lastT
        velocity = 0
        dragging = false
        startTime = anim.currentTime
        const metrics = getMetrics()
        pxPerMs = metrics.pxPerMs
        msPerSlideBase = metrics.msPerSlideBase
        if (viewport.setPointerCapture) viewport.setPointerCapture(e.pointerId)
      })

      viewport.addEventListener(
        'pointermove',
        (e) => {
          const dx = e.clientX - startX
          const dy = e.clientY - startY

          if (!dragging) {
            if (Math.abs(dx) <= DRAG_THRESHOLD || Math.abs(dx) <= Math.abs(dy)) return
            dragging = true
            track.classList.add('is-dragging')
            anim.pause()
          }

          e.preventDefault()

          const now = performance.now()
          const dt = now - lastT
          if (dt > 0) velocity = (e.clientX - lastX) / dt
          lastX = e.clientX
          lastT = now

          if (pxPerMs > 0) {
            anim.currentTime = wrapTime(startTime - dx * pxPerMs)
          }
        },
        { passive: false }
      )

      const endDrag = (e) => {
        if (viewport.releasePointerCapture) {
          try {
            viewport.releasePointerCapture(e.pointerId)
          } catch (_) {
            /* pointer may already be released */
          }
        }

        if (!dragging) return

        dragging = false
        track.classList.remove('is-dragging')

        const gestureDx = e.clientX - startX
        const gestureMs = Math.max(1, performance.now() - dragStartT)
        const gestureVelocity = gestureDx / gestureMs

        if (pxPerMs > 0 && Math.abs(gestureDx) > DRAG_THRESHOLD) {
          const flickSpeed = Math.max(Math.abs(velocity), Math.abs(gestureVelocity))
          let flickMs = flickSpeed * FLICK_FACTOR
          if (flickSpeed >= MIN_FLICK_VELOCITY && msPerSlideBase > 0) {
            flickMs = Math.max(flickMs, msPerSlideBase * MIN_FLICK_SLIDE_FRACTION)
          }
          const direction = gestureDx < 0 ? 1 : -1
          anim.currentTime = wrapTime(anim.currentTime + direction * flickMs)
        }

        anim.play()
      }

      viewport.addEventListener('pointerup', endDrag)
      viewport.addEventListener('pointercancel', endDrag)
    })
  })()

  } catch(e) { console.error(e); }
})();
})();
